import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";

import { AvailabilityFilter } from "./component";

import { IStoreState } from "../../../../reducers/types";

import {
  getCurrentFilterPrice,
  getExperiencesMaxPrice,
  getExperiencesPopularTagsList,
  getFilteredDurationTimes,
  getFilteredStartTimes,
  getFilteredTripAdvisorRating,
  getExperiencesMinPrice,
  getFilteredPopularFeatures,
  getActivitiesAvailabilityProperties,
} from "../../reducer";

import {
  setFilterDurationTimes,
  setFilterPrice,
  setFilterStartTimes,
  setFilterTripadvisorRating,
  setFilterPopularFeatures,
  resetFilterAndSort,
} from "../../actions/actions";

const mapStateToProps = (state: IStoreState) => ({
  filteredTripAdvisorRating: getFilteredTripAdvisorRating(state),
  filteredStartTimes: getFilteredStartTimes(state),
  filteredDurationTimes: getFilteredDurationTimes(state),
  maxExperiencesPrice: getExperiencesMaxPrice(state),
  filteredPrice: getCurrentFilterPrice(state),
  experiencesPopularTagsList: getExperiencesPopularTagsList(state),
  popularFeatures: getFilteredPopularFeatures(state),
  minExperiencePrice: getExperiencesMinPrice(state),
  activitiesAvailabilityProperties: getActivitiesAvailabilityProperties(state),
});

const mapDispatchToProps = {
  setFilterTripadvisorRating,
  setFilterStartTimes,
  setFilterDurationTimes,
  setFilterPrice,
  setFilterPopularFeatures,
  resetFilterAndSort,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type AvailabilityFilterProps = ConnectedProps<typeof connector>;

export const ConnectedAvailabilityFilter = withRouter(
  connector(AvailabilityFilter)
);
